module.exports = "/images/f8846546613a7f628691a9f1abe18608.png";